import { useHistory, useLocation } from 'react-router';
import useIsModal from './useIsModal';

const useModal = () => {
  const { search } = useLocation();
  const { push } = useHistory();
  const { list } = useIsModal();

  const open = ({ state, ...params }) => {
    const searchParams = new URLSearchParams(search);
    const modalQuery = params.invitePatient
      ? `invitePatient=${params.invitePatient}`
      : `modal=${params.modal}`;
    if (params && (params.modal || params.invitePatient) && list.includes(modalQuery)) {
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          searchParams.set(key, value);
        } else {
          searchParams.delete(key);
        }
      });
    }
    push(`?${searchParams.toString().replace(/%2C/g, ',')}`, state); // Keep commas unencoded because qs uses them to separate values
  };

  const close = (params, state = {}) => {
    const searchParams = new URLSearchParams(search);
    if (params && (params.modal || params.invitePatient)) {
      Object.entries(params).forEach(([key, value]) => {
        if (value && !Array.isArray(value)) searchParams.delete(key, value);
        else searchParams.delete(key);
      });
    }
    push(`?${searchParams.toString().replace(/%2C/g, ',')}`, state); // Keep commas unencoded because qs uses them to separate values
  };

  const getQueryString = (paramsToAdd, paramsToRemove) => {
    const searchParams = new URLSearchParams(search);

    if (paramsToRemove) {
      Object.entries(paramsToRemove).forEach(([key]) => {
        searchParams.delete(key);
      });
    }

    if (paramsToAdd) {
      Object.entries(paramsToAdd).forEach(([key, value]) => searchParams.set(key, value));
    }

    return `?${searchParams.toString().replace(/%2C/g, ',')}`; // Keep commas unencoded because qs uses them to separate values
  };

  return {
    open,
    close,
    getQueryString,
  };
};

export default useModal;
